import Banner from '../elements/Banner';
import BookNow from '../elements/BookNow';
import Features from '../elements/Features';
import FreeQuote from '../elements/FreeQuote';
import GetStart from '../elements/GetStart';
import HappyCustomers from '../elements/HappyCustomers';
import Locations from '../elements/Locations';
import MoveBusiness from '../elements/MoveBusiness';
import Newsletter from '../elements/Newsletter';
import Footer from '../elements/Footer';
import OurStatatics from '../elements/OurStatatics';
import Packaging from '../elements/Packaging';
import Partners from '../elements/Partners';
import Solutions from '../elements/Solutions';
import SuccessStories from '../elements/SuccessStories';
import Trust from '../elements/Trust';
import user from '../img/testimonial.png';

export default function Landing () {

    const customers = [
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    }, 

  ]

    return <>
            <Banner /> 
            <BookNow />  
            <Features /> 
            <Trust /> 
            <MoveBusiness /> 
            <Partners />
            <Solutions /> 
            <Packaging />
            <GetStart /> 
            <OurStatatics /> 
            <HappyCustomers customers={customers} /> 
            <SuccessStories />  
            <Locations />  
            <FreeQuote />   
            <Newsletter />  
            <Footer />  
        </>
};
